/**
 *  @name: layout.jsx
 *  @version: 1.0.0
 *  @author: Alexis Duarte
 *  @description: Template de las páginas, preparada para SEO.
 */

import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import "react-toastify/dist/ReactToastify.css";

// Componentes
import Header from "../components/header";
import Footer from "../components/footer";
import { ToastContainer } from "react-toastify";

/**
 *  @param: {String} title: "Título"
 *  @param: {String} description: "Descripción de la página"
 *  @param: {String} keywords: "Etiquetas, para, seo"
 */

const Layout = (props) => {
  const { title, description, keywords, children } = props;

  return (
    <Fragment>
      <Helmet>
        <title> {title || "Título"} </title>
        <meta
          name="description"
          content={description || "Descripción de la página"}
        />
        <meta name="keywords" content={keywords || "Etiquetas, para, seo"} />
      </Helmet>
      <Header title={title || "Título"} />
      {children}
      <Footer />
      <ToastContainer
        position="top-right"
        autoClose={2500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover={false}
        theme="colored"
      />
    </Fragment>
  );
};

export default Layout;
